import { SvgIconProps, createSvgIcon, styled } from '@mui/material';
import type { SvgIcon } from '@mui/material';

const Path = styled('path', { name: 'MathSymbol', slot: 'path' })(({ theme }) => ({
  fill: theme.palette.text.secondary,
}));

const Circle = styled('circle', { name: 'MathSymbol', slot: 'circle' })(({ theme }) => ({
  fill: theme.palette.secondary.light,
}));

export const MathSymbolDotIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <Circle cx="10" cy="10" r="4" />
  </svg>,
  'MathSymbolDot',
);

// TODO: fix colors
export const MathSymbolEqualIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <Circle cx="12" cy="12" r="8" />
    <Path d="M16 9H8v2h8V9ZM16 13H8v2h8v-2Z" />
  </svg>,
  'MathSymbolEqual',
);

export const MathSymbolMinusIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <Circle cx="12" cy="12" r="8" />
    <Path d="M11 13H13H16V11H13H11H8V13H11Z" />
  </svg>,
  'MathSymbolMinus',
);

export const MathSymbolMultiplyIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <Circle cx="12" cy="12" r="8" />
    <Path d="m13.413 12 2.585-2.586L14.584 8 12 10.585 9.414 8 8 9.414 10.585 12 8 14.584l1.414 1.414L12 13.413l2.585 2.585 1.414-1.414L13.413 12Z" />
  </svg>,
  'MathSymbolMultiply',
);

export const MathSymbolPlusIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <Circle cx="12" cy="12" r="8" />
    <Path d="M11 16V13H8V11H11V8H13V11H16V13H13V16H11Z" />
  </svg>,
  'MathSymbolPlus',
);

export type MathSymbolType = 'dot' | 'equal' | 'minus' | 'multiply' | 'plus';

export function MathSymbolIcon({ type, ...props }: SvgIconProps<'svg', { type: MathSymbolType }>) {
  let Icon: typeof SvgIcon;
  switch (type) {
    case 'dot':
      Icon = MathSymbolDotIcon;
      break;
    case 'equal':
      Icon = MathSymbolEqualIcon;
      break;
    case 'minus':
      Icon = MathSymbolMinusIcon;
      break;
    case 'multiply':
      Icon = MathSymbolMultiplyIcon;
      break;
    case 'plus':
      Icon = MathSymbolPlusIcon;
      break;
  }

  return Icon ? <Icon color="secondary" sx={{ width: 24, height: 24 }} {...props} /> : null;
}
